<template>
    <div class="phone">
      <div class="phone_head">
        <p class="f14">我的余额</p>
        <div class="head_name"><span class="f14">￥</span><span class="f24 weight">0.00</span></div>
      </div>
      <div class="phone_title f15">账号充值</div>
      <div class="phone_list"> 
            <div class="phone-item" :class="phoneIndex==index?'item-active':''" v-for="(item,index) in list" :key="index" @click="onMoney(index)">
                <div><span class="f16 w-600">{{ item.money }}</span><span class="f12">元</span></div>
                <div class="f12">赠送{{item.give_money}}元</div>
            </div>
            <div class="phone-item" :class="phoneIndex==-1?'item-active':''" @click="onMoney(-1)">
                <div class="f18">其他</div>
            </div>
            <div class="phone-items" v-if="(list.length+1)%3">
            </div>
      </div>
      <div class="phone_btn">立即充值</div>
    </div>
</template>
<script>
  export default{
    props:['list'],
    data(){
        return{
            phoneIndex:0
        }
    },
    methods:{
        onMoney(e){
            this.phoneIndex = e;
        }
    }
  }
</script>
  
<style lang="scss" scoped>
.phone{
    width: 100%;
    .f24{font-size: 24px;}
    .f20{font-size: 20px;}
    .f18{font-size: 18px;}
    .f14{font-size: 14px;}
    .f16{font-size: 16px;}
    .f12{font-size: 12px;}
    .weight{font-weight: bold;}
    .w-600{font-weight: 600;}

    .phone_head{
        width: 100%;
        height: 120px;
        background: #00C170;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
       
    }
    .phone_title{
        text-align: center;
        position: relative;
        font-size: 15px;
        margin: 10px 0 15px;
        &::after{
            content: '';
            width: 60px;
            height: 2px;
            background: #00C170;
            position: absolute;
            left: 50%;
            bottom: -3px;
            transform: translateX(-50%);
        }
    }
    .phone_list{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 0 16px;
        .phone-item{
            width: 32%;
            height: 50px;
            background: #F4F4F4;
            border-radius: 8px;
            color: #666;
            margin-bottom:8px ;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .item-active{
            background: #00C170;
            color: #fff;
        }
        .phone-items{
            width: 32%;
            height: 50px;
            margin-bottom:8px ;
        }
    }
    .phone_btn{
        margin: 20px 32px;
        background: #00C170;
        height: 36px;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/views/marketing/balance/part/plan/phone.vue